/**
 * Legal sayfa içerikleri - çok dilli destek
 * Her dil için içerikleri src/translations/legalContent.js içinde güncelleyebilirsiniz.
 */

const localeMap = {
  tr: "tr-TR",
  en: "en-US",
  fr: "fr-FR",
  de: "de-DE",
  es: "es-ES",
  ru: "ru-RU",
  ar: "ar-SA",
};

export function getDateLocale(lang) {
  return localeMap[lang] || "en-US";
}

export const privacyContent = {
  tr: {
    lastUpdatedLabel: "Son güncelleme:",
    sections: [
      {
        title: "1. Giriş",
        paragraphs: [
          'lineo ("biz", "bizim" veya "uygulama") olarak, kullanıcılarımızın gizliliğine önem veriyoruz. Bu Gizlilik Sözleşmesi, lineo uygulamasını ve web hizmetlerini kullandığınızda kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklamaktadır.',
        ],
      },
      {
        title: "2. Toplanan Veriler",
        paragraphs: ["Uygulamamızı kullanırken aşağıdaki verilerin toplanması söz konusu olabilir:"],
        items: [
          "Hesap bilgileri (ad, e-posta adresi, telefon numarası)",
          "İşletme ve şube bilgileri",
          "Randevu ve sıra yönetimi verileri",
          "Cihaz bilgileri ve kullanım istatistikleri",
          "Oturum ve güvenlik logları",
        ],
      },
      {
        title: "3. Verilerin Kullanım Amaçları",
        paragraphs: ["Topladığımız veriler aşağıdaki amaçlarla kullanılmaktadır:"],
        items: [
          "Hizmetlerimizi sunmak ve geliştirmek",
          "Kullanıcı hesaplarını yönetmek",
          "Teknik destek sağlamak",
          "Güvenlik ve dolandırıcılık önleme",
          "Yasal yükümlülüklerimizi yerine getirmek",
        ],
      },
      {
        title: "4. Veri Paylaşımı",
        paragraphs: [
          "Kişisel verilerinizi, yasal zorunluluklar dışında üçüncü taraflarla paylaşmayız. Hizmet sağlayıcılarımız (hosting, analitik vb.) verilerinizi yalnızca hizmet sunumu amacıyla işler ve gizlilik sözleşmeleriyle bağlıdır.",
        ],
      },
      {
        title: "5. Veri Güvenliği",
        paragraphs: [
          "Verilerinizi korumak için endüstri standardı güvenlik önlemleri uyguluyoruz. İletişim şifreleme (HTTPS/TLS), güvenli kimlik doğrulama ve düzenli güvenlik denetimleri kullanıyoruz.",
        ],
      },
      {
        title: "6. Haklarınız",
        paragraphs: ["KVKK ve GDPR kapsamında aşağıdaki haklara sahipsiniz:"],
        items: [
          "Verilerinize erişim talep etme",
          "Düzeltme veya silme talep etme",
          "İşleme itiraz etme",
          "Veri taşınabilirliği talep etme",
        ],
      },
      {
        title: "7. İletişim",
        paragraphs: [
          "Gizlilik ile ilgili sorularınız için bizimle iletişime geçebilirsiniz. Bu sözleşmede yapılan değişiklikler bu sayfada yayınlanacaktır.",
        ],
      },
    ],
  },
  en: {
    lastUpdatedLabel: "Last updated:",
    sections: [
      {
        title: "1. Introduction",
        paragraphs: [
          'As lineo ("we", "us" or "application"), we value the privacy of our users. This Privacy Policy explains how your personal data is collected, used and protected when you use the lineo application and web services.',
        ],
      },
      {
        title: "2. Data Collected",
        paragraphs: ["The following data may be collected when using our application:"],
        items: [
          "Account information (name, email address, phone number)",
          "Business and branch information",
          "Appointment and queue management data",
          "Device information and usage statistics",
          "Session and security logs",
        ],
      },
      {
        title: "3. Purposes of Data Use",
        paragraphs: ["The data we collect is used for the following purposes:"],
        items: [
          "To provide and improve our services",
          "To manage user accounts",
          "To provide technical support",
          "Security and fraud prevention",
          "To fulfill our legal obligations",
        ],
      },
      {
        title: "4. Data Sharing",
        paragraphs: [
          "We do not share your personal data with third parties except where legally required. Our service providers (hosting, analytics, etc.) process your data only for the purpose of providing services and are bound by privacy agreements.",
        ],
      },
      {
        title: "5. Data Security",
        paragraphs: [
          "We implement industry-standard security measures to protect your data. We use communication encryption (HTTPS/TLS), secure authentication and regular security audits.",
        ],
      },
      {
        title: "6. Your Rights",
        paragraphs: ["Under KVKK and GDPR, you have the following rights:"],
        items: [
          "Request access to your data",
          "Request correction or deletion",
          "Object to processing",
          "Request data portability",
        ],
      },
      {
        title: "7. Contact",
        paragraphs: [
          "You can contact us for any questions regarding privacy. Changes to this policy will be published on this page.",
        ],
      },
    ],
  },
  fr: {
    lastUpdatedLabel: "Dernière mise à jour :",
    sections: [
      {
        title: "1. Introduction",
        paragraphs: [
          'En tant que lineo ("nous", "notre" ou "application"), nous accordons une grande importance à la confidentialité de nos utilisateurs. Cette Politique de confidentialité explique comment vos données personnelles sont collectées, utilisées et protégées lorsque vous utilisez l\'application lineo et les services web.',
        ],
      },
      {
        title: "2. Données collectées",
        paragraphs: ["Les données suivantes peuvent être collectées lors de l'utilisation de notre application :"],
        items: [
          "Informations de compte (nom, adresse e-mail, numéro de téléphone)",
          "Informations sur l'entreprise et les succursales",
          "Données de gestion des rendez-vous et des files d'attente",
          "Informations sur l'appareil et statistiques d'utilisation",
          "Journaux de session et de sécurité",
        ],
      },
      {
        title: "3. Objectifs d'utilisation des données",
        paragraphs: ["Les données que nous collectons sont utilisées aux fins suivantes :"],
        items: [
          "Fournir et améliorer nos services",
          "Gérer les comptes utilisateurs",
          "Fournir un support technique",
          "Sécurité et prévention de la fraude",
          "Remplir nos obligations légales",
        ],
      },
      {
        title: "4. Partage des données",
        paragraphs: [
          "Nous ne partageons pas vos données personnelles avec des tiers sauf obligation légale. Nos prestataires de services (hébergement, analytique, etc.) traitent vos données uniquement dans le but de fournir des services et sont liés par des accords de confidentialité.",
        ],
      },
      {
        title: "5. Sécurité des données",
        paragraphs: [
          "Nous mettons en œuvre des mesures de sécurité conformes aux normes de l'industrie pour protéger vos données. Nous utilisons le chiffrement des communications (HTTPS/TLS), l'authentification sécurisée et des audits de sécurité réguliers.",
        ],
      },
      {
        title: "6. Vos droits",
        paragraphs: ["Conformément au RGPD, vous disposez des droits suivants :"],
        items: [
          "Demander l'accès à vos données",
          "Demander la correction ou la suppression",
          "Vous opposer au traitement",
          "Demander la portabilité des données",
        ],
      },
      {
        title: "7. Contact",
        paragraphs: [
          "Vous pouvez nous contacter pour toute question concernant la confidentialité. Les modifications de cette politique seront publiées sur cette page.",
        ],
      },
    ],
  },
  de: {
    lastUpdatedLabel: "Zuletzt aktualisiert:",
    sections: [
      {
        title: "1. Einleitung",
        paragraphs: [
          'Als lineo ("wir", "uns" oder "Anwendung") legen wir großen Wert auf die Privatsphäre unserer Nutzer. Diese Datenschutzrichtlinie erklärt, wie Ihre personenbezogenen Daten bei der Nutzung der lineo-Anwendung und Webdienste erhoben, verwendet und geschützt werden.',
        ],
      },
      {
        title: "2. Erhobene Daten",
        paragraphs: ["Bei der Nutzung unserer Anwendung können folgende Daten erhoben werden:"],
        items: [
          "Kontoinformationen (Name, E-Mail-Adresse, Telefonnummer)",
          "Geschäfts- und Filialinformationen",
          "Termin- und Warteschlangenverwaltungsdaten",
          "Geräteinformationen und Nutzungsstatistiken",
          "Sitzungs- und Sicherheitsprotokolle",
        ],
      },
      {
        title: "3. Zwecke der Datennutzung",
        paragraphs: ["Die von uns erhobenen Daten werden für folgende Zwecke verwendet:"],
        items: [
          "Bereitstellung und Verbesserung unserer Dienste",
          "Verwaltung von Benutzerkonten",
          "Technische Unterstützung",
          "Sicherheit und Betrugsprävention",
          "Erfüllung unserer gesetzlichen Verpflichtungen",
        ],
      },
      {
        title: "4. Datenweitergabe",
        paragraphs: [
          "Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, außer wenn gesetzlich vorgeschrieben. Unsere Dienstleister (Hosting, Analytik usw.) verarbeiten Ihre Daten nur zum Zweck der Dienstleistungserbringung und sind an Vertraulichkeitsvereinbarungen gebunden.",
        ],
      },
      {
        title: "5. Datensicherheit",
        paragraphs: [
          "Wir implementieren branchenübliche Sicherheitsmaßnahmen zum Schutz Ihrer Daten. Wir verwenden Kommunikationsverschlüsselung (HTTPS/TLS), sichere Authentifizierung und regelmäßige Sicherheitsaudits.",
        ],
      },
      {
        title: "6. Ihre Rechte",
        paragraphs: ["Nach DSGVO haben Sie folgende Rechte:"],
        items: [
          "Zugang zu Ihren Daten verlangen",
          "Berichtigung oder Löschung verlangen",
          "Widerspruch gegen die Verarbeitung einlegen",
          "Datenübertragbarkeit verlangen",
        ],
      },
      {
        title: "7. Kontakt",
        paragraphs: [
          "Sie können uns bei Fragen zum Datenschutz kontaktieren. Änderungen dieser Richtlinie werden auf dieser Seite veröffentlicht.",
        ],
      },
    ],
  },
  es: {
    lastUpdatedLabel: "Última actualización:",
    sections: [
      {
        title: "1. Introducción",
        paragraphs: [
          'Como lineo ("nosotros", "nuestra" o "aplicación"), valoramos la privacidad de nuestros usuarios. Esta Política de Privacidad explica cómo se recopilan, utilizan y protegen sus datos personales cuando utiliza la aplicación lineo y los servicios web.',
        ],
      },
      {
        title: "2. Datos recopilados",
        paragraphs: ["Se pueden recopilar los siguientes datos al usar nuestra aplicación:"],
        items: [
          "Información de la cuenta (nombre, correo electrónico, número de teléfono)",
          "Información empresarial y de sucursales",
          "Datos de gestión de citas y colas",
          "Información del dispositivo y estadísticas de uso",
          "Registros de sesión y seguridad",
        ],
      },
      {
        title: "3. Propósitos del uso de datos",
        paragraphs: ["Los datos que recopilamos se utilizan para los siguientes propósitos:"],
        items: [
          "Proporcionar y mejorar nuestros servicios",
          "Gestionar cuentas de usuario",
          "Proporcionar soporte técnico",
          "Seguridad y prevención de fraudes",
          "Cumplir con nuestras obligaciones legales",
        ],
      },
      {
        title: "4. Compartir datos",
        paragraphs: [
          "No compartimos sus datos personales con terceros excepto cuando sea legalmente requerido. Nuestros proveedores de servicios (alojamiento, analítica, etc.) procesan sus datos solo con el propósito de proporcionar servicios y están sujetos a acuerdos de confidencialidad.",
        ],
      },
      {
        title: "5. Seguridad de datos",
        paragraphs: [
          "Implementamos medidas de seguridad estándar de la industria para proteger sus datos. Utilizamos cifrado de comunicaciones (HTTPS/TLS), autenticación segura y auditorías de seguridad regulares.",
        ],
      },
      {
        title: "6. Sus derechos",
        paragraphs: ["Según el RGPD, tiene los siguientes derechos:"],
        items: [
          "Solicitar acceso a sus datos",
          "Solicitar corrección o eliminación",
          "Oponerse al procesamiento",
          "Solicitar portabilidad de datos",
        ],
      },
      {
        title: "7. Contacto",
        paragraphs: [
          "Puede contactarnos para cualquier pregunta sobre privacidad. Los cambios en esta política se publicarán en esta página.",
        ],
      },
    ],
  },
  ru: {
    lastUpdatedLabel: "Последнее обновление:",
    sections: [
      {
        title: "1. Введение",
        paragraphs: [
          'Как lineo ("мы", "наш" или "приложение"), мы ценим конфиденциальность наших пользователей. Эта Политика конфиденциальности объясняет, как собираются, используются и защищаются ваши персональные данные при использовании приложения lineo и веб-сервисов.',
        ],
      },
      {
        title: "2. Собираемые данные",
        paragraphs: ["При использовании нашего приложения могут собираться следующие данные:"],
        items: [
          "Информация об аккаунте (имя, email, номер телефона)",
          "Информация о бизнесе и филиалах",
          "Данные управления записями и очередями",
          "Информация об устройстве и статистика использования",
          "Журналы сессий и безопасности",
        ],
      },
      {
        title: "3. Цели использования данных",
        paragraphs: ["Собранные нами данные используются для следующих целей:"],
        items: [
          "Предоставление и улучшение наших услуг",
          "Управление учётными записями",
          "Техническая поддержка",
          "Безопасность и предотвращение мошенничества",
          "Выполнение юридических обязательств",
        ],
      },
      {
        title: "4. Передача данных",
        paragraphs: [
          "Мы не передаём ваши персональные данные третьим лицам, за исключением случаев, предусмотренных законом. Наши поставщики услуг (хостинг, аналитика и т.д.) обрабатывают ваши данные только в целях предоставления услуг и связаны соглашениями о конфиденциальности.",
        ],
      },
      {
        title: "5. Безопасность данных",
        paragraphs: [
          "Мы применяем отраслевые стандарты безопасности для защиты ваших данных. Используем шифрование связи (HTTPS/TLS), безопасную аутентификацию и регулярные проверки безопасности.",
        ],
      },
      {
        title: "6. Ваши права",
        paragraphs: ["В соответствии с GDPR вы имеете следующие права:"],
        items: [
          "Запрашивать доступ к вашим данным",
          "Запрашивать исправление или удаление",
          "Возражать против обработки",
          "Запрашивать переносимость данных",
        ],
      },
      {
        title: "7. Контакты",
        paragraphs: [
          "Вы можете связаться с нами по вопросам конфиденциальности. Изменения в этой политике будут опубликованы на этой странице.",
        ],
      },
    ],
  },
  ar: {
    lastUpdatedLabel: "آخر تحديث:",
    sections: [
      {
        title: "1. المقدمة",
        paragraphs: [
          'بصفتنا lineo ("نحن" أو "التطبيق")، نحن نقدر خصوصية مستخدمينا. توضح سياسة الخصوصية هذه كيفية جمع بياناتك الشخصية واستخدامها وحمايتها عند استخدام تطبيق lineo وخدمات الويب.',
        ],
      },
      {
        title: "2. البيانات المجمعة",
        paragraphs: ["قد يتم جمع البيانات التالية عند استخدام تطبيقنا:"],
        items: [
          "معلومات الحساب (الاسم، البريد الإلكتروني، رقم الهاتف)",
          "معلومات الأعمال والفروع",
          "بيانات إدارة المواعيد والطوابير",
          "معلومات الجهاز وإحصائيات الاستخدام",
          "سجلات الجلسات والأمان",
        ],
      },
      {
        title: "3. أغراض استخدام البيانات",
        paragraphs: ["تُستخدم البيانات التي نجمعها للأغراض التالية:"],
        items: [
          "تقديم خدماتنا وتحسينها",
          "إدارة حسابات المستخدمين",
          "تقديم الدعم الفني",
          "الأمان ومنع الاحتيال",
          "الوفاء بالتزاماتنا القانونية",
        ],
      },
      {
        title: "4. مشاركة البيانات",
        paragraphs: [
          "لا نشارك بياناتك الشخصية مع أطراف ثالثة إلا عند الالتزام القانوني. معالجات الخدمة لدينا (الاستضافة، التحليلات، إلخ) تعالج بياناتك فقط لغرض تقديم الخدمات وملتزمون باتفاقيات الخصوصية.",
        ],
      },
      {
        title: "5. أمان البيانات",
        paragraphs: [
          "نطبق إجراءات أمان قياسية في الصناعة لحماية بياناتك. نستخدم تشفير الاتصالات (HTTPS/TLS) والمصادقة الآمنة ومراجعات الأمان المنتظمة.",
        ],
      },
      {
        title: "6. حقوقك",
        paragraphs: ["بموجب اللائحة العامة لحماية البيانات، لديك الحقوق التالية:"],
        items: [
          "طلب الوصول إلى بياناتك",
          "طلب التصحيح أو الحذف",
          "الاعتراض على المعالجة",
          "طلب قابلية نقل البيانات",
        ],
      },
      {
        title: "7. التواصل",
        paragraphs: [
          "يمكنك التواصل معنا لأي أسئلة تتعلق بالخصوصية. سيتم نشر التغييرات على هذه السياسة على هذه الصفحة.",
        ],
      },
    ],
  },
};

export const termsContent = {
  tr: {
    lastUpdatedLabel: "Son güncelleme:",
    sections: [
      {
        title: "1. Hizmet Tanımı",
        paragraphs: [
          "lineo, işletmelerin sıra ve randevu yönetimini kolaylaştıran bir web uygulamasıdır. Bu Kullanım Koşulları, uygulamamızı ve hizmetlerimizi kullanırken uymanız gereken kuralları belirler.",
        ],
      },
      {
        title: "2. Hesap Sorumluluğu",
        paragraphs: [
          "Kayıt olurken verdiğiniz bilgilerin doğru ve güncel olmasından siz sorumlusunuz. Hesap güvenliğinizi korumak ve şifrenizi gizli tutmak sizin yükümlülüğünüzdür. Hesabınız üzerinden yapılan tüm işlemlerden siz sorumlusunuz.",
        ],
      },
      {
        title: "3. Kabul Edilemez Kullanım",
        paragraphs: ["Aşağıdaki kullanımlar yasaktır:"],
        items: [
          "Yasalara aykırı faaliyetler",
          "Başkalarının haklarını ihlal etmek",
          "Zararlı yazılım yaymak veya sisteme saldırmak",
          "Hizmeti kötüye kullanmak veya aşırı yük bindirmek",
          "Üçüncü tarafların verilerini izinsiz kullanmak",
        ],
      },
      {
        title: "4. Fikri Mülkiyet",
        paragraphs: [
          "lineo ve tüm içeriği, tasarımı ve yazılımı bizim mülkiyetimizdedir. İzinsiz kopyalama, dağıtma veya türev çalışmalar oluşturma yasaktır.",
        ],
      },
      {
        title: "5. Hizmet Değişiklikleri",
        paragraphs: [
          "Hizmetlerimizi geliştirmek amacıyla değişiklik yapma hakkımızı saklı tutarız. Önemli değişikliklerde kullanıcıları bilgilendireceğiz. Hizmeti kullanmaya devam etmeniz, güncel koşulları kabul ettiğiniz anlamına gelir.",
        ],
      },
      {
        title: "6. Sorumluluk Sınırlaması",
        paragraphs: [
          'lineo "olduğu gibi" sunulmaktadır. Dolaylı, arızi veya sonuç olarak ortaya çıkan zararlardan sorumlu tutulamayız. Yasal düzenlemelerin izin verdiği ölçüde sorumluluk sınırlandırılmıştır.',
        ],
      },
      {
        title: "7. Fesih",
        paragraphs: [
          "Bu koşulları ihlal etmeniz durumunda hesabınızı askıya alma veya sonlandırma hakkımızı saklı tutarız. Hesabınızı istediğiniz zaman kapatabilirsiniz.",
        ],
      },
      {
        title: "8. Uygulanacak Hukuk",
        paragraphs: [
          "Bu sözleşme Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda Türk mahkemeleri yetkilidir.",
        ],
      },
      {
        title: "9. İletişim",
        paragraphs: ["Kullanım Koşulları ile ilgili sorularınız için bizimle iletişime geçebilirsiniz."],
      },
    ],
  },
  en: {
    lastUpdatedLabel: "Last updated:",
    sections: [
      {
        title: "1. Service Description",
        paragraphs: [
          "lineo is a web application that simplifies queue and appointment management for businesses. These Terms of Service define the rules you must follow when using our application and services.",
        ],
      },
      {
        title: "2. Account Responsibility",
        paragraphs: [
          "You are responsible for the accuracy and currency of the information you provide when registering. It is your responsibility to protect your account security and keep your password confidential. You are responsible for all activities performed through your account.",
        ],
      },
      {
        title: "3. Unacceptable Use",
        paragraphs: ["The following uses are prohibited:"],
        items: [
          "Illegal activities",
          "Violating the rights of others",
          "Distributing malware or attacking the system",
          "Abusing the service or placing excessive load",
          "Using third-party data without permission",
        ],
      },
      {
        title: "4. Intellectual Property",
        paragraphs: [
          "lineo and all its content, design and software are our property. Unauthorized copying, distribution or creation of derivative works is prohibited.",
        ],
      },
      {
        title: "5. Service Changes",
        paragraphs: [
          "We reserve the right to make changes to improve our services. We will inform users of significant changes. Continued use of the service means you accept the current terms.",
        ],
      },
      {
        title: "6. Limitation of Liability",
        paragraphs: [
          'lineo is provided "as is". We cannot be held liable for indirect, incidental or consequential damages. Liability is limited to the extent permitted by applicable law.',
        ],
      },
      {
        title: "7. Termination",
        paragraphs: [
          "We reserve the right to suspend or terminate your account if you violate these terms. You can close your account at any time.",
        ],
      },
      {
        title: "8. Governing Law",
        paragraphs: [
          "This agreement is subject to the laws of the Republic of Turkey. Turkish courts have jurisdiction over disputes.",
        ],
      },
      {
        title: "9. Contact",
        paragraphs: ["You can contact us for any questions regarding the Terms of Service."],
      },
    ],
  },
  fr: {
    lastUpdatedLabel: "Dernière mise à jour :",
    sections: [
      {
        title: "1. Description du service",
        paragraphs: [
          "lineo est une application web qui simplifie la gestion des files d'attente et des rendez-vous pour les entreprises. Ces Conditions d'utilisation définissent les règles à suivre lors de l'utilisation de notre application et de nos services.",
        ],
      },
      {
        title: "2. Responsabilité du compte",
        paragraphs: [
          "Vous êtes responsable de l'exactitude et de l'actualité des informations fournies lors de l'inscription. Il est de votre responsabilité de protéger la sécurité de votre compte et de garder votre mot de passe confidentiel. Vous êtes responsable de toutes les activités effectuées via votre compte.",
        ],
      },
      {
        title: "3. Utilisation inacceptable",
        paragraphs: ["Les utilisations suivantes sont interdites :"],
        items: [
          "Activités illégales",
          "Violer les droits d'autrui",
          "Distribuer des logiciels malveillants ou attaquer le système",
          "Abuser du service ou surcharger",
          "Utiliser des données tierces sans autorisation",
        ],
      },
      {
        title: "4. Propriété intellectuelle",
        paragraphs: [
          "lineo et tout son contenu, design et logiciel sont notre propriété. La copie, la distribution ou la création d'œuvres dérivées non autorisées est interdite.",
        ],
      },
      {
        title: "5. Modifications du service",
        paragraphs: [
          "Nous nous réservons le droit d'apporter des modifications pour améliorer nos services. Nous informerons les utilisateurs des changements importants. L'utilisation continue du service signifie que vous acceptez les conditions actuelles.",
        ],
      },
      {
        title: "6. Limitation de responsabilité",
        paragraphs: [
          'lineo est fourni "tel quel". Nous ne pouvons être tenus responsables des dommages indirects, accessoires ou consécutifs. La responsabilité est limitée dans la mesure permise par la loi applicable.',
        ],
      },
      {
        title: "7. Résiliation",
        paragraphs: [
          "Nous nous réservons le droit de suspendre ou de résilier votre compte en cas de violation de ces conditions. Vous pouvez fermer votre compte à tout moment.",
        ],
      },
      {
        title: "8. Droit applicable",
        paragraphs: [
          "Cet accord est soumis aux lois de la République de Turquie. Les tribunaux turcs ont compétence pour les litiges.",
        ],
      },
      {
        title: "9. Contact",
        paragraphs: ["Vous pouvez nous contacter pour toute question concernant les Conditions d'utilisation."],
      },
    ],
  },
  de: {
    lastUpdatedLabel: "Zuletzt aktualisiert:",
    sections: [
      {
        title: "1. Dienstbeschreibung",
        paragraphs: [
          "lineo ist eine Webanwendung, die die Warteschlangen- und Terminverwaltung für Unternehmen vereinfacht. Diese Nutzungsbedingungen legen die Regeln fest, die Sie bei der Nutzung unserer Anwendung und Dienste befolgen müssen.",
        ],
      },
      {
        title: "2. Kontoverantwortung",
        paragraphs: [
          "Sie sind für die Richtigkeit und Aktualität der bei der Registrierung angegebenen Informationen verantwortlich. Es liegt in Ihrer Verantwortung, die Sicherheit Ihres Kontos zu schützen und Ihr Passwort vertraulich zu halten. Sie sind für alle über Ihr Konto durchgeführten Aktivitäten verantwortlich.",
        ],
      },
      {
        title: "3. Unzulässige Nutzung",
        paragraphs: ["Folgende Nutzungen sind untersagt:"],
        items: [
          "Illegale Aktivitäten",
          "Rechte anderer verletzen",
          "Malware verbreiten oder das System angreifen",
          "Den Dienst missbrauchen oder überlasten",
          "Drittdaten ohne Erlaubnis nutzen",
        ],
      },
      {
        title: "4. Geistiges Eigentum",
        paragraphs: [
          "lineo und alle seine Inhalte, Designs und Software sind unser Eigentum. Unbefugtes Kopieren, Verteilen oder Erstellen abgeleiteter Werke ist untersagt.",
        ],
      },
      {
        title: "5. Dienständerungen",
        paragraphs: [
          "Wir behalten uns das Recht vor, Änderungen zur Verbesserung unserer Dienste vorzunehmen. Wir werden Nutzer über wesentliche Änderungen informieren. Die fortgesetzte Nutzung des Dienstes bedeutet, dass Sie die aktuellen Bedingungen akzeptieren.",
        ],
      },
      {
        title: "6. Haftungsbeschränkung",
        paragraphs: [
          'lineo wird "wie besehen" bereitgestellt. Wir können nicht für indirekte, zufällige oder Folgeschäden haftbar gemacht werden. Die Haftung ist auf das gesetzlich zulässige Maß beschränkt.',
        ],
      },
      {
        title: "7. Kündigung",
        paragraphs: [
          "Wir behalten uns das Recht vor, Ihr Konto bei Verstoß gegen diese Bedingungen zu sperren oder zu kündigen. Sie können Ihr Konto jederzeit schließen.",
        ],
      },
      {
        title: "8. Anwendbares Recht",
        paragraphs: [
          "Diese Vereinbarung unterliegt den Gesetzen der Republik Türkei. Türkische Gerichte sind für Streitigkeiten zuständig.",
        ],
      },
      {
        title: "9. Kontakt",
        paragraphs: ["Sie können uns bei Fragen zu den Nutzungsbedingungen kontaktieren."],
      },
    ],
  },
  es: {
    lastUpdatedLabel: "Última actualización:",
    sections: [
      {
        title: "1. Descripción del servicio",
        paragraphs: [
          "lineo es una aplicación web que simplifica la gestión de colas y citas para empresas. Estos Términos de Servicio definen las reglas que debe seguir al usar nuestra aplicación y servicios.",
        ],
      },
      {
        title: "2. Responsabilidad de la cuenta",
        paragraphs: [
          "Usted es responsable de la exactitud y actualidad de la información proporcionada al registrarse. Es su responsabilidad proteger la seguridad de su cuenta y mantener su contraseña confidencial. Usted es responsable de todas las actividades realizadas a través de su cuenta.",
        ],
      },
      {
        title: "3. Uso inaceptable",
        paragraphs: ["Los siguientes usos están prohibidos:"],
        items: [
          "Actividades ilegales",
          "Violar los derechos de otros",
          "Distribuir malware o atacar el sistema",
          "Abusar del servicio o sobrecargarlo",
          "Usar datos de terceros sin permiso",
        ],
      },
      {
        title: "4. Propiedad intelectual",
        paragraphs: [
          "lineo y todo su contenido, diseño y software son nuestra propiedad. Está prohibida la copia, distribución o creación de obras derivadas no autorizadas.",
        ],
      },
      {
        title: "5. Cambios del servicio",
        paragraphs: [
          "Nos reservamos el derecho de realizar cambios para mejorar nuestros servicios. Informaremos a los usuarios sobre cambios significativos. El uso continuado del servicio significa que acepta los términos actuales.",
        ],
      },
      {
        title: "6. Limitación de responsabilidad",
        paragraphs: [
          'lineo se proporciona "tal cual". No podemos ser responsables de daños indirectos, incidentales o consecuentes. La responsabilidad está limitada en la medida permitida por la ley aplicable.',
        ],
      },
      {
        title: "7. Terminación",
        paragraphs: [
          "Nos reservamos el derecho de suspender o terminar su cuenta si viola estos términos. Puede cerrar su cuenta en cualquier momento.",
        ],
      },
      {
        title: "8. Ley aplicable",
        paragraphs: [
          "Este acuerdo está sujeto a las leyes de la República de Turquía. Los tribunales turcos tienen jurisdicción sobre las disputas.",
        ],
      },
      {
        title: "9. Contacto",
        paragraphs: ["Puede contactarnos para cualquier pregunta sobre los Términos de Servicio."],
      },
    ],
  },
  ru: {
    lastUpdatedLabel: "Последнее обновление:",
    sections: [
      {
        title: "1. Описание услуги",
        paragraphs: [
          "lineo — веб-приложение, упрощающее управление очередями и записями для бизнеса. Эти Условия использования определяют правила, которым вы должны следовать при использовании нашего приложения и услуг.",
        ],
      },
      {
        title: "2. Ответственность за аккаунт",
        paragraphs: [
          "Вы несёте ответственность за точность и актуальность информации, предоставленной при регистрации. Вы обязаны защищать безопасность своего аккаунта и хранить пароль в секрете. Вы несёте ответственность за все действия, совершённые через ваш аккаунт.",
        ],
      },
      {
        title: "3. Недопустимое использование",
        paragraphs: ["Следующее использование запрещено:"],
        items: [
          "Незаконная деятельность",
          "Нарушение прав других",
          "Распространение вредоносного ПО или атаки на систему",
          "Злоупотребление сервисом или перегрузка",
          "Использование данных третьих лиц без разрешения",
        ],
      },
      {
        title: "4. Интеллектуальная собственность",
        paragraphs: [
          "lineo и весь его контент, дизайн и программное обеспечение являются нашей собственностью. Несанкционированное копирование, распространение или создание производных произведений запрещено.",
        ],
      },
      {
        title: "5. Изменения услуги",
        paragraphs: [
          "Мы оставляем за собой право вносить изменения для улучшения наших услуг. Мы будем информировать пользователей о значительных изменениях. Продолжение использования сервиса означает принятие текущих условий.",
        ],
      },
      {
        title: "6. Ограничение ответственности",
        paragraphs: [
          'lineo предоставляется "как есть". Мы не несём ответственности за косвенные, случайные или последующие убытки. Ответственность ограничена в пределах, разрешённых применимым законодательством.',
        ],
      },
      {
        title: "7. Прекращение",
        paragraphs: [
          "Мы оставляем за собой право приостановить или прекратить ваш аккаунт в случае нарушения этих условий. Вы можете закрыть свой аккаунт в любое время.",
        ],
      },
      {
        title: "8. Применимое право",
        paragraphs: [
          "Настоящее соглашение регулируется законами Турецкой Республики. Турецкие суды имеют юрисдикцию по спорам.",
        ],
      },
      {
        title: "9. Контакты",
        paragraphs: ["Вы можете связаться с нами по любым вопросам, касающимся Условий использования."],
      },
    ],
  },
  ar: {
    lastUpdatedLabel: "آخر تحديث:",
    sections: [
      {
        title: "1. وصف الخدمة",
        paragraphs: [
          "lineo هو تطبيق ويب يبسط إدارة الطوابير والمواعيد للشركات. تحدد شروط الاستخدام هذه القواعد التي يجب اتباعها عند استخدام تطبيقنا وخدماتنا.",
        ],
      },
      {
        title: "2. مسؤولية الحساب",
        paragraphs: [
          "أنت مسؤول عن دقة وحداثة المعلومات المقدمة عند التسجيل. من مسؤوليتك حماية أمان حسابك والحفاظ على سرية كلمة المرور. أنت مسؤول عن جميع الأنشطة التي تتم عبر حسابك.",
        ],
      },
      {
        title: "3. الاستخدام غير المقبول",
        paragraphs: ["الاستخدامات التالية محظورة:"],
        items: [
          "الأنشطة غير القانونية",
          "انتهاك حقوق الآخرين",
          "توزيع البرمجيات الخبيثة أو مهاجمة النظام",
          "إساءة استخدام الخدمة أو تحميلها بشكل مفرط",
          "استخدام بيانات الأطراف الثالثة دون إذن",
        ],
      },
      {
        title: "4. الملكية الفكرية",
        paragraphs: [
          "lineo وجميع محتوياته وتصميمه وبرمجياته ملكنا. يُحظر النسخ أو التوزيع أو إنشاء أعمال مشتقة دون إذن.",
        ],
      },
      {
        title: "5. تغييرات الخدمة",
        paragraphs: [
          "نحتفظ بالحق في إجراء تغييرات لتحسين خدماتنا. سنخطر المستخدمين بالتغييرات المهمة. الاستمرار في استخدام الخدمة يعني قبولك للشروط الحالية.",
        ],
      },
      {
        title: "6. تحديد المسؤولية",
        paragraphs: [
          'يُقدم lineo "كما هو". لا يمكننا تحمل المسؤولية عن الأضرار غير المباشرة أو العرضية أو التبعية. المسؤولية محدودة بالقدر المسموح به بموجب القانون المعمول به.',
        ],
      },
      {
        title: "7. الإنهاء",
        paragraphs: [
          "نحتفظ بالحق في تعليق أو إنهاء حسابك في حالة انتهاك هذه الشروط. يمكنك إغلاق حسابك في أي وقت.",
        ],
      },
      {
        title: "8. القانون الحاكم",
        paragraphs: [
          "هذا الاتفاق يخضع لقوانين جمهورية تركيا. المحاكم التركية لها الولاية القضائية على النزاعات.",
        ],
      },
      {
        title: "9. التواصل",
        paragraphs: ["يمكنك التواصل معنا لأي أسئلة تتعلق بشروط الاستخدام."],
      },
    ],
  },
};

export const cookieContent = {
  tr: {
    lastUpdatedLabel: "Son güncelleme:",
    sections: [
      {
        title: "1. Çerezler Nedir?",
        paragraphs: [
          "Çerezler, web sitelerinin cihazınıza (bilgisayar, tablet, telefon) kaydettiği küçük metin dosyalarıdır. lineo, hizmetlerimizi sunmak ve kullanıcı deneyimini iyileştirmek amacıyla çerezler kullanabilir.",
        ],
      },
      {
        title: "2. Kullandığımız Çerez Türleri",
        subSections: [
          {
            subTitle: "Zorunlu Çerezler",
            paragraphs: [
              "Uygulamanın temel işlevleri için gereklidir. Oturum yönetimi, güvenlik ve tercih saklama (dil, tema) gibi işlemler bu çerezler olmadan çalışmaz.",
            ],
          },
          {
            subTitle: "İşlevsel Çerezler",
            paragraphs: [
              "Tercihlerinizi hatırlamak için kullanılır (örneğin dil seçimi, açık/koyu tema). Bu çerezler olmadan her ziyarette ayarlarınızı yeniden yapmanız gerekebilir.",
            ],
          },
          {
            subTitle: "Analitik Çerezler",
            paragraphs: [
              "Uygulamanın nasıl kullanıldığını anlamamıza yardımcı olur. Anonim ve toplu veriler toplanır; kişisel tanımlama yapılmaz.",
            ],
          },
        ],
      },
      {
        title: "3. Çerez Yönetimi",
        paragraphs: [
          "Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilir veya silebilirsiniz. Ancak zorunlu çerezleri kapatmanız durumunda uygulamanın bazı özellikleri düzgün çalışmayabilir.",
        ],
      },
      {
        title: "4. Üçüncü Taraf Çerezleri",
        paragraphs: [
          "lineo, analitik veya diğer hizmetler için üçüncü taraf sağlayıcılar kullanıyorsa, bu sağlayıcıların kendi çerez politikaları geçerli olabilir.",
        ],
      },
      {
        title: "5. Güncellemeler",
        paragraphs: [
          "Bu Çerez Politikası zaman zaman güncellenebilir. Değişiklikler bu sayfada yayınlanacak ve son güncelleme tarihi belirtilecektir.",
        ],
      },
      {
        title: "6. İletişim",
        paragraphs: ["Çerezler hakkında sorularınız için bizimle iletişime geçebilirsiniz."],
      },
    ],
  },
  en: {
    lastUpdatedLabel: "Last updated:",
    sections: [
      {
        title: "1. What Are Cookies?",
        paragraphs: [
          "Cookies are small text files that websites save to your device (computer, tablet, phone). lineo may use cookies to provide our services and improve the user experience.",
        ],
      },
      {
        title: "2. Types of Cookies We Use",
        subSections: [
          {
            subTitle: "Essential Cookies",
            paragraphs: [
              "Required for core application functions. Session management, security and preference storage (language, theme) cannot work without these cookies.",
            ],
          },
          {
            subTitle: "Functional Cookies",
            paragraphs: [
              "Used to remember your preferences (e.g. language selection, light/dark theme). Without these cookies, you may need to reconfigure your settings on each visit.",
            ],
          },
          {
            subTitle: "Analytics Cookies",
            paragraphs: [
              "Help us understand how the application is used. Anonymous and aggregate data is collected; no personal identification is made.",
            ],
          },
        ],
      },
      {
        title: "3. Cookie Management",
        paragraphs: [
          "You can disable or delete cookies from your browser settings. However, disabling essential cookies may cause some application features to not work properly.",
        ],
      },
      {
        title: "4. Third-Party Cookies",
        paragraphs: [
          "If lineo uses third-party providers for analytics or other services, those providers' own cookie policies may apply.",
        ],
      },
      {
        title: "5. Updates",
        paragraphs: [
          "This Cookie Policy may be updated from time to time. Changes will be published on this page and the last update date will be indicated.",
        ],
      },
      {
        title: "6. Contact",
        paragraphs: ["You can contact us for any questions about cookies."],
      },
    ],
  },
  fr: {
    lastUpdatedLabel: "Dernière mise à jour :",
    sections: [
      {
        title: "1. Qu'est-ce que les cookies ?",
        paragraphs: [
          "Les cookies sont de petits fichiers texte que les sites web enregistrent sur votre appareil (ordinateur, tablette, téléphone). lineo peut utiliser des cookies pour fournir nos services et améliorer l'expérience utilisateur.",
        ],
      },
      {
        title: "2. Types de cookies que nous utilisons",
        subSections: [
          {
            subTitle: "Cookies essentiels",
            paragraphs: [
              "Nécessaires pour les fonctions principales de l'application. La gestion des sessions, la sécurité et le stockage des préférences (langue, thème) ne peuvent pas fonctionner sans ces cookies.",
            ],
          },
          {
            subTitle: "Cookies fonctionnels",
            paragraphs: [
              "Utilisés pour mémoriser vos préférences (ex. sélection de langue, thème clair/sombre). Sans ces cookies, vous devrez peut-être reconfigurer vos paramètres à chaque visite.",
            ],
          },
          {
            subTitle: "Cookies analytiques",
            paragraphs: [
              "Nous aident à comprendre comment l'application est utilisée. Des données anonymes et agrégées sont collectées ; aucune identification personnelle n'est effectuée.",
            ],
          },
        ],
      },
      {
        title: "3. Gestion des cookies",
        paragraphs: [
          "Vous pouvez désactiver ou supprimer les cookies dans les paramètres de votre navigateur. Cependant, la désactivation des cookies essentiels peut empêcher certaines fonctionnalités de l'application de fonctionner correctement.",
        ],
      },
      {
        title: "4. Cookies tiers",
        paragraphs: [
          "Si lineo utilise des prestataires tiers pour l'analytique ou d'autres services, les politiques de cookies de ces prestataires peuvent s'appliquer.",
        ],
      },
      {
        title: "5. Mises à jour",
        paragraphs: [
          "Cette Politique des cookies peut être mise à jour de temps en temps. Les modifications seront publiées sur cette page et la date de dernière mise à jour sera indiquée.",
        ],
      },
      {
        title: "6. Contact",
        paragraphs: ["Vous pouvez nous contacter pour toute question concernant les cookies."],
      },
    ],
  },
  de: {
    lastUpdatedLabel: "Zuletzt aktualisiert:",
    sections: [
      {
        title: "1. Was sind Cookies?",
        paragraphs: [
          "Cookies sind kleine Textdateien, die Websites auf Ihrem Gerät (Computer, Tablet, Telefon) speichern. lineo kann Cookies verwenden, um unsere Dienste bereitzustellen und die Benutzererfahrung zu verbessern.",
        ],
      },
      {
        title: "2. Arten von Cookies, die wir verwenden",
        subSections: [
          {
            subTitle: "Essenzielle Cookies",
            paragraphs: [
              "Erforderlich für die Kernfunktionen der Anwendung. Sitzungsverwaltung, Sicherheit und Speicherung von Einstellungen (Sprache, Thema) funktionieren ohne diese Cookies nicht.",
            ],
          },
          {
            subTitle: "Funktionale Cookies",
            paragraphs: [
              "Werden verwendet, um Ihre Präferenzen zu speichern (z.B. Sprachauswahl, helles/dunkles Thema). Ohne diese Cookies müssen Sie möglicherweise bei jedem Besuch Ihre Einstellungen neu konfigurieren.",
            ],
          },
          {
            subTitle: "Analyse-Cookies",
            paragraphs: [
              "Helfen uns zu verstehen, wie die Anwendung genutzt wird. Anonyme und aggregierte Daten werden gesammelt; keine persönliche Identifizierung erfolgt.",
            ],
          },
        ],
      },
      {
        title: "3. Cookie-Verwaltung",
        paragraphs: [
          "Sie können Cookies in Ihren Browsereinstellungen deaktivieren oder löschen. Das Deaktivieren essenzieller Cookies kann dazu führen, dass einige Anwendungsfunktionen nicht ordnungsgemäß funktionieren.",
        ],
      },
      {
        title: "4. Cookies von Drittanbietern",
        paragraphs: [
          "Wenn lineo Drittanbieter für Analysen oder andere Dienste verwendet, können die eigenen Cookie-Richtlinien dieser Anbieter gelten.",
        ],
      },
      {
        title: "5. Aktualisierungen",
        paragraphs: [
          "Diese Cookie-Richtlinie kann von Zeit zu Zeit aktualisiert werden. Änderungen werden auf dieser Seite veröffentlicht und das Datum der letzten Aktualisierung wird angegeben.",
        ],
      },
      {
        title: "6. Kontakt",
        paragraphs: ["Sie können uns bei Fragen zu Cookies kontaktieren."],
      },
    ],
  },
  es: {
    lastUpdatedLabel: "Última actualización:",
    sections: [
      {
        title: "1. ¿Qué son las cookies?",
        paragraphs: [
          "Las cookies son pequeños archivos de texto que los sitios web guardan en su dispositivo (ordenador, tableta, teléfono). lineo puede usar cookies para proporcionar nuestros servicios y mejorar la experiencia del usuario.",
        ],
      },
      {
        title: "2. Tipos de cookies que utilizamos",
        subSections: [
          {
            subTitle: "Cookies esenciales",
            paragraphs: [
              "Necesarias para las funciones principales de la aplicación. La gestión de sesiones, la seguridad y el almacenamiento de preferencias (idioma, tema) no pueden funcionar sin estas cookies.",
            ],
          },
          {
            subTitle: "Cookies funcionales",
            paragraphs: [
              "Se utilizan para recordar sus preferencias (ej. selección de idioma, tema claro/oscuro). Sin estas cookies, puede que necesite reconfigurar su configuración en cada visita.",
            ],
          },
          {
            subTitle: "Cookies analíticas",
            paragraphs: [
              "Nos ayudan a entender cómo se utiliza la aplicación. Se recopilan datos anónimos y agregados; no se realiza identificación personal.",
            ],
          },
        ],
      },
      {
        title: "3. Gestión de cookies",
        paragraphs: [
          "Puede desactivar o eliminar las cookies en la configuración de su navegador. Sin embargo, desactivar las cookies esenciales puede hacer que algunas funciones de la aplicación no funcionen correctamente.",
        ],
      },
      {
        title: "4. Cookies de terceros",
        paragraphs: [
          "Si lineo utiliza proveedores terceros para analítica u otros servicios, pueden aplicarse las propias políticas de cookies de esos proveedores.",
        ],
      },
      {
        title: "5. Actualizaciones",
        paragraphs: [
          "Esta Política de cookies puede actualizarse de vez en cuando. Los cambios se publicarán en esta página y se indicará la fecha de última actualización.",
        ],
      },
      {
        title: "6. Contacto",
        paragraphs: ["Puede contactarnos para cualquier pregunta sobre las cookies."],
      },
    ],
  },
  ru: {
    lastUpdatedLabel: "Последнее обновление:",
    sections: [
      {
        title: "1. Что такое cookies?",
        paragraphs: [
          "Cookies — это небольшие текстовые файлы, которые веб-сайты сохраняют на вашем устройстве (компьютер, планшет, телефон). lineo может использовать cookies для предоставления наших услуг и улучшения пользовательского опыта.",
        ],
      },
      {
        title: "2. Типы cookies, которые мы используем",
        subSections: [
          {
            subTitle: "Необходимые cookies",
            paragraphs: [
              "Требуются для основных функций приложения. Управление сессиями, безопасность и хранение настроек (язык, тема) не работают без этих cookies.",
            ],
          },
          {
            subTitle: "Функциональные cookies",
            paragraphs: [
              "Используются для запоминания ваших предпочтений (например, выбор языка, светлая/тёмная тема). Без этих cookies вам может потребоваться перенастраивать параметры при каждом посещении.",
            ],
          },
          {
            subTitle: "Аналитические cookies",
            paragraphs: [
              "Помогают нам понять, как используется приложение. Собираются анонимные и агрегированные данные; персональная идентификация не производится.",
            ],
          },
        ],
      },
      {
        title: "3. Управление cookies",
        paragraphs: [
          "Вы можете отключить или удалить cookies в настройках браузера. Однако отключение необходимых cookies может привести к тому, что некоторые функции приложения не будут работать должным образом.",
        ],
      },
      {
        title: "4. Сторонние cookies",
        paragraphs: [
          "Если lineo использует сторонних поставщиков для аналитики или других услуг, могут применяться собственные политики cookies этих поставщиков.",
        ],
      },
      {
        title: "5. Обновления",
        paragraphs: [
          "Эта Политика cookies может периодически обновляться. Изменения будут опубликованы на этой странице с указанием даты последнего обновления.",
        ],
      },
      {
        title: "6. Контакты",
        paragraphs: ["Вы можете связаться с нами по любым вопросам, касающимся cookies."],
      },
    ],
  },
  ar: {
    lastUpdatedLabel: "آخر تحديث:",
    sections: [
      {
        title: "1. ما هي ملفات تعريف الارتباط؟",
        paragraphs: [
          "ملفات تعريف الارتباط هي ملفات نصية صغيرة تحفظها مواقع الويب على جهازك (كمبيوتر، جهاز لوحي، هاتف). قد يستخدم lineo ملفات تعريف الارتباط لتقديم خدماتنا وتحسين تجربة المستخدم.",
        ],
      },
      {
        title: "2. أنواع ملفات تعريف الارتباط التي نستخدمها",
        subSections: [
          {
            subTitle: "ملفات تعريف الارتباط الأساسية",
            paragraphs: [
              "مطلوبة لوظائف التطبيق الأساسية. إدارة الجلسات والأمان وتخزين التفضيلات (اللغة، السمة) لا تعمل بدون هذه الملفات.",
            ],
          },
          {
            subTitle: "ملفات تعريف الارتباط الوظيفية",
            paragraphs: [
              "تُستخدم لتذكر تفضيلاتك (مثل اختيار اللغة، السمة الفاتحة/الداكنة). بدون هذه الملفات، قد تحتاج إلى إعادة تكوين إعداداتك في كل زيارة.",
            ],
          },
          {
            subTitle: "ملفات تعريف الارتباط التحليلية",
            paragraphs: [
              "تساعدنا على فهم كيفية استخدام التطبيق. يتم جمع بيانات مجهولة ومجمعة؛ لا يتم إجراء تحديد شخصي.",
            ],
          },
        ],
      },
      {
        title: "3. إدارة ملفات تعريف الارتباط",
        paragraphs: [
          "يمكنك تعطيل أو حذف ملفات تعريف الارتباط من إعدادات المتصفح. ومع ذلك، قد يؤدي تعطيل الملفات الأساسية إلى عدم عمل بعض ميزات التطبيق بشكل صحيح.",
        ],
      },
      {
        title: "4. ملفات تعريف الارتباط من أطراف ثالثة",
        paragraphs: [
          "إذا استخدم lineo مزودين من أطراف ثالثة للتحليلات أو خدمات أخرى، فقد تنطبق سياسات ملفات تعريف الارتباط الخاصة بهؤلاء المزودين.",
        ],
      },
      {
        title: "5. التحديثات",
        paragraphs: [
          "قد يتم تحديث سياسة ملفات تعريف الارتباط هذه من وقت لآخر. سيتم نشر التغييرات على هذه الصفحة وتحديد تاريخ آخر تحديث.",
        ],
      },
      {
        title: "6. التواصل",
        paragraphs: ["يمكنك التواصل معنا لأي أسئلة حول ملفات تعريف الارتباط."],
      },
    ],
  },
};
